<script setup lang="ts">
import { computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuth } from '@/api/useAuth'
import { useUserStore } from '@/stores/user'
import { ConfigProvider } from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import Layout from './components/Layout.vue'

const route = useRoute()
const { getProfile, initAuthState } = useAuth()
const userStore = useUserStore()

// 判断是否为登录页面
const isLoginPage = computed(() => route.path === '/login' || route.path.startsWith('/login'))

// 判断是否应该显示登录页面
const shouldShowLogin = computed(() => {  
  // 如果当前在登录页面，显示路由视图（让路由处理登录页面）
  if (isLoginPage.value) {
    return true
  }
  // 如果不在登录页面但未登录，显示路由视图（让路由重定向到登录页）
  if (!userStore.isLoggedIn) {
    return true
  }
  // 如果已登录且不在登录页面，显示主布局
  return false
})

// 监听登录状态变化
watch(() => userStore.isLoggedIn, (newValue, oldValue) => {
})

// 监听当前用户变化
watch(() => userStore.currentUser, (newValue, oldValue) => {
})

// 应用启动时自动获取用户信息
const initializeApp = async () => {
  // 初始化认证状态
  initAuthState()
  
  // 检查是否有有效的token
      const token = localStorage.getItem('apiToken')
  if (token) {
    try {
      // 尝试获取用户信息来验证登录状态
      await getProfile()
    } catch (error) {
      console.error('初始化时获取用户信息失败:', error)
    }
  }
}

// 组件挂载时执行初始化
onMounted(() => {
  initializeApp()
})
</script>

<template>
  <ConfigProvider :locale="zhCN">
    <router-view v-if="shouldShowLogin" />
    <Layout v-else />
  </ConfigProvider>
</template>

<style>
#app {
  height: 100vh;
  margin: 0;
  padding: 0;
}
</style>
